import {FETCH_PORTFOLIOS} from '../actions/types';

export default function(state = [],action){
  switch(action.type){
    case FETCH_PORTFOLIOS:
      const portfolios = action.payload.data.portfolios;
      return [...portfolios];
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/portfolios.js